export default {"src":"/_next/static/media/expand.243914ff.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};